import { Button } from "@/components/ui/button";
import type { UseTemplateLayoutReturn } from "@/lib/template-studio/repository/useTemplateLayout";

type TemplateLayoutLoadStatusProps = Pick<
  UseTemplateLayoutReturn,
  "error" | "isRetryable" | "retry"
>;

/** Full-page loading or error state while `useTemplateLayout` has no template. */
export const TemplateLayoutLoadStatus = ({
  error,
  isRetryable,
  retry,
}: TemplateLayoutLoadStatusProps) =>
  error ? (
    <main
      className="flex min-h-full flex-col items-center justify-center gap-3 bg-gray-50 p-8 text-center"
      role="alert"
      aria-live="polite"
    >
      <p className="max-w-md text-sm text-gray-700">{error.message}</p>
      {isRetryable ? (
        <Button variant="outline" size="sm" onPress={retry}>
          Try again
        </Button>
      ) : null}
    </main>
  ) : (
    <main
      className="flex min-h-full items-center justify-center bg-gray-50 p-8"
      aria-busy="true"
      aria-live="polite"
    >
      <p className="text-sm text-gray-600">Loading template…</p>
    </main>
  );
